module.exports = __webpack_public_path__ + "static/media/full-logo.b5f4a477.png";